<template>
  <div>
    <v-row>
      <v-col md="12" v-if="!isViewModal">
        <v-btn size="small" color="blue-grey" prepend-icon="$plus" class="pl-4 text-white" @click="newPresentation">
          <span>Agregar Detalle</span>
        </v-btn>
      </v-col>

      <v-col md="12">
        <v-data-table :headers="table_headers" :items="shipment_order.items" style="border: solid 1px #1c1c1c" :hide-default-footer="true" :items-per-page="100">
          <template v-slot:item="{ item }">
            <tr>
              <td>
                <div class="nowrap">{{ item.product.name }}</div>
                <span class="nowrap text-caption text-grey-600">SKU: {{ item.product.sku }}</span>
              </td>
              <td>
                <span class="nowrap text-caption text-grey-600">{{ item.product_status.name }}</span>
              </td>
              <td>
                {{ item.amount }}
              </td>
              <td>
                <v-row class="ma-0">
                  <v-col cols="6" class="pt-0" v-if="item.product.tiene_control_por_lotes && item.lote">
                    <div class="text-caption">Lote</div>
                    <div class="text-caption nowrap">{{ typeof item.lote === "string" ? item.lote : item.lote?.id }}</div>
                  </v-col>
                  <v-col cols="6" class="pt-0" v-if="item.product.tiene_control_por_serie && item.serie">
                    <div class="text-caption">Serie</div>
                    <div class="text-caption nowrap">{{ typeof item.serie === "string" ? item.serie : item.serie?.id }}</div>
                  </v-col>
                  <v-col cols="6" class="pt-0" v-if="item.product.requiere_fecha_expiracion && item.expiration_date">
                    <div class="text-caption nowrap">Fecha mínima de expiración</div>
                    <div class="text-caption nowrap">{{ item.expiration_date }}</div>
                  </v-col>
                  <v-col cols="6" class="pt-0" v-if="item.product.tiene_control_de_calidad && item.quality">
                    <div class="text-caption">Calidad</div>
                    <div class="text-caption nowrap">{{ item.quality != null ? item.quality.name : "" }}</div>
                  </v-col>
                  <v-col cols="6" class="pt-0" v-if="item.product.tiene_control_por_descriptivo_1 && item.descriptivo_1 && isAliasEnabled('descriptivo_1')">
                    <div class="text-caption">
                      {{ getAliasName("descriptivo_1") }}
                    </div>
                    <div class="text-caption nowrap">{{ item.descriptivo_1 }}</div>
                  </v-col>
                  <v-col cols="6" class="pt-0" v-if="item.product.tiene_control_por_descriptivo_2 && item.descriptivo_2 && isAliasEnabled('descriptivo_2')">
                    <div class="text-caption">
                      {{ getAliasName("descriptivo_2") }}
                    </div>
                    <div class="text-caption">{{ item.descriptivo_2 }}</div>
                  </v-col>
                  <v-col cols="6" class="pt-0" v-if="item.product.tiene_control_por_descriptivo_3 && item.descriptivo_3 && isAliasEnabled('descriptivo_3')">
                    <div class="text-caption">
                      {{ getAliasName("descriptivo_3") }}
                    </div>
                    <div class="text-caption nowrap">{{ typeof item.descriptivo_3 === "string" ? item.descriptivo_3 : item.descriptivo_3?.name }}</div>
                  </v-col>
                  <v-col cols="6" class="pt-0" v-if="item.storage_units_amount">
                    <div class="text-caption">Almacenamiento</div>
                    <div class="text-caption nowrap">{{ item.storage_units_amount }}</div>
                  </v-col>
                </v-row>
              </td>

              <td class="text-center" style="width: 110px" v-if="!isViewModal">
                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" small color="blue" class="mr-2" v-on:click="editPresentation(item)" size="small"> mdi-pencil</v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" small color="red" class="mr-2" v-on:click="removePresentation(item, 'custom')" size="small">mdi-delete </v-icon>
                  </template>
                  <span>Remover</span>
                </v-tooltip>
              </td>
              <td v-else></td>
            </tr>
          </template>
        </v-data-table>

        <!-- Resumen de totales -->
        <div>
          <v-row class="ma-0">
            <v-col cols="12" md="6" class="pl-0">
              <span class="nowrap text-caption text-grey-600">
                Total de ítems: <strong class="text-black">{{ shipment_order.items.length }}</strong>
              </span>
              <span class="nowrap text-caption text-grey-600 ml-4">
                Cantidad total: <strong class="text-black">{{ totalAmount }}</strong>
              </span>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>

    <!-- START FORM DIALOG -->
    <ModalPresentacion v-model="dialog_presentacion" :itemEdit="itemEdit" :shipment_order="shipment_order" @addPresentation="addPresentation" />
  </div>
</template>

<script>
import ModalPresentacion from "./ModalPresentacion.vue";
import AliasMixin from "@/mixins/AliasMixin.vue";
export default {
  created() {
    this.$validator = this.validator;
  },
  components: { ModalPresentacion },
  mixins: [AliasMixin],
  props: {
    open: Boolean,
    shipment_order: Object,
    addProduct: Function,
    removeProduct: Function,
    validator: Object,

    isViewModal: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    ivas: [],
    dialog_presentacion: false,
    itemEdit: null,
    itemEditIndex: null,
    table_headers: [
      { title: "Producto", key: "product.name", sortable: false },
      { title: "Estado del producto", key: "product_status.name", sortable: false },
      { title: "Cantidad", key: "amount", sortable: false },
      { title: "Atributos", key: "", sortable: false },
      { title: "Accion", sortable: false },
    ],
  }),
  computed: {
    totalAmount() {
      return this.shipment_order.items.reduce((sum, item) => {
        return sum + (parseFloat(item.amount) || 0);
      }, 0);
    },
  },
  watch: {
    shipment_order: {
      handler: function (newValue) {},
      deep: true,
    },
  },
  mounted() {
    // Ya no necesita inicializar headers, vienen del padre
  },
  methods: {
    newPresentation() {
      this.itemEdit = null;
      this.itemEditIndex = null;
      this.dialog_presentacion = true;
    },
    editPresentation(item) {
      this.itemEditIndex = this.shipment_order.items.indexOf(item);
      this.itemEdit = Object.assign({}, item);
      this.dialog_presentacion = true;
    },
    addPresentation(item) {
      if (this.itemEditIndex == null) {
        this.$emit("addProduct", item);
      } else {
        this.$emit("addProduct", item, this.itemEditIndex);
      }
    },
    removePresentation(item, colection_name) {
      if (colection_name == "custom") {
        const index_item = this.shipment_order.items.indexOf(item);
        if (index_item > -1) this.$emit("removeProduct", index_item);
      }
    },
  },
};
</script>
